import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import getConfig from '../../../../../../../../util/config';
import { getThumbBySize } from '../../../../../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../../../../../constants/image-size-codes';
import { ALBUM_PRIVACY } from '../../../../../../../../constants/albums';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    slideshow: PropTypes.shape({
      intro_layout: PropTypes.shape({
        account_card: PropTypes.shape({
          front_preview_file_url: PropTypes.string,
        }),
      }),
      layouts: PropTypes.shape({
        total: PropTypes.number,
        records: PropTypes.arrayOf(
          PropTypes.shape({
            account_card: PropTypes.shape({
              front_preview_file_url: PropTypes.string,
            }),
          }),
        ),
      }),
      photos: PropTypes.shape({
        total: PropTypes.number,
        records: PropTypes.arrayOf(
          PropTypes.shape({
            photo: PropTypes.shape({
              id: PropTypes.string,
            }),
          }),
        ),
      }),
    }),
  }),
};

const AlbumSlideshowMeta = ({ album }) => {
  const {
    app: { pageUrl },
  } = getConfig();
  const introLayout =
    album?.slideshow?.intro_layout?.account_card?.front_preview_file_url;
  const firstLayout =
    album?.slideshow?.layouts?.records?.[0]?.account_card
      ?.front_preview_file_url;
  const firstPhotoUrl = getThumbBySize(
    album?.slideshow?.photos?.records?.[0]?.photo?.thumbnail_urls,
    IMAGE_SIZE_CODE.MEDIUM2X,
  )?.url;
  const title = `${
    album?.name ? `${album?.name} ` : ''
  }Slideshow - Waldo Photos`;
  const description = `View ${
    album?.name ? `${album?.name} ` : ''
  }slideshow now!`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {(introLayout || firstLayout || firstPhotoUrl) && (
        <meta
          property="og:image"
          content={introLayout || firstLayout || firstPhotoUrl}
        />
      )}
      {album?.privacy === ALBUM_PRIVACY.PRIVATE && (
        <meta name="robots" content="noindex" />
      )}
    </Helmet>
  );
};

AlbumSlideshowMeta.propTypes = propTypes;

export default AlbumSlideshowMeta;
